import { Dispatch, SetStateAction, useEffect, useRef } from "react";
import { Typography } from "components/atoms";
import { NavLeftArrow, NavRightArrow } from "components/atoms/Icon";
import { MonthNavigatorPopUp } from "./monthNavigatorPopUp";
import { useScreenSize } from "hooks";
import "./index.scss";

interface IProps {
  incrementMonth: () => void;
  decrementMonth: () => void;
  text: string;
  isLeftDisable?: boolean;
  isRightDisable?: boolean;
  setIsMonthPopUpShow?: Dispatch<SetStateAction<boolean>>;
  setIsYearPopUpShow?: Dispatch<SetStateAction<boolean>>;
  popUpIncrementMonth?: (month: number) => void;
  popUpIncrementYears?: (year: number) => void;
  isMonthPopUpShow?: boolean;
  isYearPopUpShow?: boolean;
  maxDate?: any;
  minDate?: any;
  currentMonth?: any;
  theme?: "light" | "dark";
}

export const MonthNavigator = ({
  incrementMonth,
  decrementMonth,
  text,
  isLeftDisable,
  isRightDisable,
  setIsMonthPopUpShow,
  setIsYearPopUpShow,
  popUpIncrementMonth,
  popUpIncrementYears,
  isMonthPopUpShow,
  isYearPopUpShow,
  maxDate,
  minDate,
  currentMonth,
  theme
}: IProps) => {
  const screen = useScreenSize();

  const monthYearPopupRef = useRef<any>(null);

  const setMonthPopUpShow = () => {
    if (screen.width > 575) {
      setIsMonthPopUpShow && setIsMonthPopUpShow((prev) => !prev);
      setIsYearPopUpShow && setIsYearPopUpShow((prev) => false);
    }
  };

  const setYearPopUpShow = () => {
    if (screen.width > 575) {
      setIsYearPopUpShow && setIsYearPopUpShow((prev) => !prev);
      setIsMonthPopUpShow && setIsMonthPopUpShow((prev) => false);
    }
  };

  const handleClickOutside = (event: MouseEvent) => {
    if (
      monthYearPopupRef.current &&
      !monthYearPopupRef.current.contains(event.target as Node)
    ) {
      setIsMonthPopUpShow && setIsMonthPopUpShow(false);
      setIsYearPopUpShow && setIsYearPopUpShow(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="today-year-section">
      <NavLeftArrow
        theme={theme}
        onClick={decrementMonth}
        style={isLeftDisable ? "disable-nav-arrow" : "nav-arrow"}
        isDisable={isLeftDisable}
      />
      <Typography variant="h4Med" styles="month-and-year-style" label={text} onClick={setYearPopUpShow} />

      <NavRightArrow
        theme={theme}
        onClick={incrementMonth}
        style={isRightDisable ? "disable-nav-arrow" : "nav-arrow"}
        isDisable={isRightDisable}
      />

      {(isMonthPopUpShow || isYearPopUpShow) && (
        <div className="month-navigator-view" ref={monthYearPopupRef}>
          <MonthNavigatorPopUp
            isMonthPopUpShow={isMonthPopUpShow}
            isYearPopUpShow={isYearPopUpShow}
            popUpIncrementMonth={popUpIncrementMonth}
            popUpIncrementYears={popUpIncrementYears}
            maxDate={maxDate}
            minDate={minDate}
            studyPlannerCurrentMonth={currentMonth}
            setMonthPopUpShow={setMonthPopUpShow}
            theme={theme}
          />
        </div>
      )}
    </div>
  );
};
